module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"search":"Search"},"fr_FR":{"search":"Rechercher"}}')
  delete Component.options._Ctor
}
